import {Component, computed, EventEmitter, Input, Output, signal} from '@angular/core';
import {UserSubscription} from "../../../../../user/user-subscription";
import {IUsedAiCredits} from "../../../../../store/reducers/used-ai-credits.reducer";

@Component({
    selector: 'db-trial-limit-indicator',
    templateUrl: './trial-limit-indicator.component.html',
    styleUrl: './trial-limit-indicator.component.scss',
    standalone: false
})
export class TrialLimitIndicatorComponent {
  @Input('percentageLeft') set freePlanPercentage(num: number) {
    this.planPercentageLeft.set(num);
  }
  @Input() companyInfo: any;

  @Input('usedAiCredits') set AiCredits(num: IUsedAiCredits) {
    if (!num) {
      return;
    }
    this.creditsLimit.set(num.planLimit);
    this.creditsUsed.set(num.alreadyUsed);
  }

  @Input('daysUntilNext') set daysUntilNextPayment(num: number) {
    this.daysUntilNext.set(num);
  }

  @Input() set userSubscription(sub: UserSubscription) {
    this._userSubscription = sub;
    if (sub?.editTotal !== undefined) {
      this.creditsLimit.set(sub.editTotal);
    }
    if (sub?.editUsed !== undefined) {
      this.creditsUsed.set(sub.editUsed);
    }
  }
  get userSubscription(): UserSubscription { return this._userSubscription; }
  private _userSubscription: UserSubscription;
  @Input() freeDaysCount!: number;
  @Output() onUpgrade: EventEmitter<void> = new EventEmitter();

  planPercentageLeft = signal(0);
  daysUntilNext = signal(0);
  creditsLimit = signal(30);
  creditsUsed = signal(0);

  showFreePlanMessage = computed(() => {
    return this.daysUntilNext() === 1;
  });

  aiCreditsMessage = computed(() => {
    const limit = +this.creditsLimit();
    if (this.aiCreditsMode() === 'danger' && !this.showFreePlanMessage()) {
      return {
        showMessage: true,
        className: 'danger' as 'danger',
        title: 'You’ve used all your trial AI credits.',
        subtitle: 'Get more and keep building with 10Web Pro.'
      };
    }

    if (this.aiCreditsMode() === 'warning' && !this.showFreePlanMessage()) {
      return {
        showMessage: true,
        className: 'warning' as 'warning',
        title: 'Seems you’re enjoying building with AI.',
        subtitle: 'Go Pro to get more credits & secure your site.'
      };
    }

    return {
      showMessage: false,
      className: this.aiCreditsMode(),
      title: 'You’ve used all your trial AI credits.',
      subtitle: 'Get more and keep building with 10Web Pro.'
    };
  });

  aiCreditsMode = computed(() => {
    if (this.creditsUsed() === +this.creditsLimit()) {
      return 'danger';
    }

    if (this.creditsUsed() >= +this.creditsLimit() / 2) {
      return 'warning';
    }

    return 'black';
  });

  creditsUsedPercentage = computed(() => {
    const limit = this.creditsLimit();
    const used = this.creditsUsed();
    return limit > 0 ? (used / limit) * 100 : 0;
  });

}
